<template>
    <div>
        <home-header  @getCity="getCity"></home-header>
        <div class="guide_wrapper wrapper">
            <div class="wrap">
                <!--装修学堂-->
                <img src="../assets/image/home/learn_title.png" alt="装修学堂" class="title_img"/>
                <div class="swiper_box">
                    <!-- 左按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/left.png" alt="" class="btn_img" @click="imageClick('left')"
                             v-if="currPage>1"/>
                    </div>
                    <!-- 中间轮播-->
                    <div class="banner_box" v-if="news_data.length">
                        <el-carousel arrow="never" indicator-position="none" :autoplay="false" ref="banner"
                                     class="banner">
                            <el-carousel-item
                                v-for="(item, index) in Math.ceil(news_data.length / 4)"
                                :key="index"
                                class="news_wrap"
                            >
                                <div v-for="(el, ind) in news_data.slice((item - 1)*4, item*4)" :key="ind" class="news_item guide_news_item"
                                     @click="clk_info(el)">
                                    <img :src="el.thumb">
                                    <div class="news_info">
                                        <p class="title">{{el.title}}</p>
                                        <p class="text-overflow info">{{el.describe}}</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div v-else class="wait_box">敬请期待...</div>
                    <!-- 右按钮-->
                    <div class="img_box">
                        <img src="../assets/image/coms/right.png" alt="" class="btn_img" @click="imageClick('right')"
                             v-if="news_data.length!=0"/>
                    </div>
                </div>
                <!--装修风格-->
                <img src="../assets/image/guide/style_title.png" alt="" class="title_img" v-if="guidestyle_img.length > 0">
                <div>
                    <template v-for="(item, index) in guidestyle_img">
                        <img :key="index" :src="item.thumb" alt="" class="mb60" style="width: 100%;display: block"
                             @click="clk_link(item.link)"/>
                    </template>
                </div>
                <!-- 官方账号-->
                <account></account>
            </div>
            <!-- 底部-->
            <copyright></copyright>
        </div>
    </div>
</template>

<script>
    import HomeHeader from "../components/blueheader";
    import account from "../components/account";
    import copyright from "../components/copyright";
    import lib_website from "../libs/lib_website";

    export default {
        name: "guide",
        components: {
            HomeHeader,
            account,
            copyright
        },
        data() {
            return {
                guidestyle_img: [], //装修风格
                currPage: 1, //当前页
                news_data: [], //轮播数据
            }
        },
        methods: {
            // 获取城市
            getCity(city) {
                lib_website.ui(6, 1, this.init_guidestyle)
                this.select_page(1)
            },
            select_page(page) {
                lib_website.news(2,page,4, this.init_news_list)
            },
            init_news_list(data) {
                console.log(data)
                this.news_data = data;
                // this.news_data = _array._convertArray(JSON.parse(JSON.stringify(data)),4)
            },
            init_guidestyle(data) {
                this.guidestyle_img = data
            },
            // 图片链接
            clk_link(link) {
                if(link) {
                    window.location.href = link
                }
            },

            imageClick(val) {
                if (val == 'right') {
                    // 请求下一页
                    this.currPage++;
                    this.select_page(this.currPage)
                    console.log( this.$refs.banner, '下')
                    this.$refs.banner.next()
                } else {
                    // 请求上一页
                    this.currPage--;
                    this.select_page(this.currPage)
                    if(this.$refs.banner) {
                        this.$refs.banner.prev()
                    }
                }
            },
            clk_info(item) {
                console.log(item)
                this.$router.push(`/info?id=${item.id}`)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/pages/guide.less";
    @import "../assets/style/coms/banner.less";
</style>
